import React from 'react';
import PublicLayout from './PublicLayout';

export default function SecurityPage() {
  return (
    <PublicLayout title="Security at ScensobConnect" eyebrow="Trust">
      <p className="lead">Security isn't a checkbox — it's a posture. Here's what we do, and what we ask of you.</p>
      <h2>Encryption</h2>
      <ul>
        <li><strong>In transit:</strong> TLS 1.2+ everywhere. HSTS forced on production domain.</li>
        <li><strong>At rest:</strong> AES-256 for sensitive fields (SSN, EIN, payment metadata). MongoDB encryption at rest enabled.</li>
      </ul>
      <h2>Application security</h2>
      <ul>
        <li>OWASP Top 10 review on every release.</li>
        <li>Server-side XSS sanitization on every user-supplied string (job titles, descriptions, messages, addresses).</li>
        <li>Strict CSP-compatible response headers: <code>X-Content-Type-Options</code>, <code>X-Frame-Options</code>, <code>Referrer-Policy</code>, <code>Permissions-Policy</code>.</li>
        <li>Password hashing via bcrypt (cost factor 12).</li>
        <li>Cryptographically secure RNG (Python <code>secrets</code> module) for OTPs, temp passwords, and reward draws.</li>
        <li>Mandatory password confirmation on destructive actions (archive, delete, bulk operations).</li>
        <li>Role-based access control on every endpoint, enforced server-side.</li>
        <li>Verification gate: workers, employers, and agents cannot use the platform until an admin approves their profile.</li>
      </ul>
      <h2>Infrastructure</h2>
      <ul>
        <li>Hosted in SOC 2 Type II compliant cloud regions.</li>
        <li>Network segmentation between web tier, application tier, and database.</li>
        <li>Daily encrypted backups with 30-day retention.</li>
        <li>Disaster recovery RTO: 4 hours. RPO: 1 hour.</li>
      </ul>
      <h2>Vulnerability disclosure</h2>
      <p>Found something? We want to know.</p>
      <ul>
        <li>Email <a href="mailto:security@scensobconnect.com">security@scensobconnect.com</a> (PGP key on request).</li>
        <li>Please do not disclose publicly before we've had 90 days to remediate.</li>
        <li>We acknowledge reports within 24 hours and aim to remediate critical issues within 7 days.</li>
      </ul>
      <h2>Compliance</h2>
      <ul>
        <li><strong>HIPAA:</strong> BAA available for covered-entity customers. See our <a href="/hipaa">HIPAA notice</a>.</li>
        <li><strong>SOC 2 Type II:</strong> Audit in progress, report available under NDA.</li>
        <li><strong>CCPA / GDPR:</strong> Data-subject requests at <a href="mailto:privacy@scensobconnect.com">privacy@scensobconnect.com</a>.</li>
      </ul>
    </PublicLayout>
  );
}
